
import { groupBy } from 'lodash'
import sponsorDatas from '@/../public/json/sponsor.json'
import { defineComponent, computed } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'SponsorFooter',
  setup () {
    const { languageType, languagePack } = useStore()
    const sponsorGroups = computed(() => Object.entries(groupBy(sponsorDatas.map((data) => {
      return {
        level: data.level,
        id: data.id,
        name: data.name[languageType.value],
        link: data.link,
        image: data.image
      }
    }), 'level'))
      .sort((entryA, entryB) => {
        const sponsorSequence = ['titanium', 'diamond', 'gold', 'silver', 'bronze', 'co-organizer', 'special-thanks']
        return sponsorSequence.indexOf(entryA[0]) - sponsorSequence.indexOf(entryB[0])
      })
    )

    return {
      sponsorGroups,
      languagePack
    }
  }
})
